import nucampsiteImg from "./imgs/nucamp/nucampSite.PNG";
import perspectiveSoundImg from "./imgs/nucamp/portfolioprojectWIP.PNG";
import nucampReactImg from "./imgs/nucamp/nucampreact.PNG";
import googleImg from "./imgs/google.PNG";
import rockPaperImg from "./imgs/rockpaperscissors.PNG";
import candyMuseumImg from "./imgs/candymuseum.PNG";
import coinFlipperImg from "./imgs/coinflipper.PNG";
import colorBoxesImg from "./imgs/colorboxes.PNG";
import diceRollImg from "./imgs/diceroll.PNG";
import hangmanImg from "./imgs/hangman.PNG";
import lightsoutImg from "./imgs/lightsout.PNG";
import lotteryImg from "./imgs/lottery.PNG";
import pokemonImg from "./imgs/pokemon.PNG";
import scoreKeeperImg from "./imgs/scorekeeper.PNG";
import toDoImg from "./imgs/todolist.PNG";
import yahtzeeImg from "./imgs/yahtzee.PNG";
import dadJokesImg from "./imgs/dadjokes.PNG";


const projectInfo = [
    {
        name: "NuCamp Website",
        src: nucampsiteImg,
        link: "https://elated-galileo-c63498.netlify.app/",
        title: "NuCamp Site",
        struggle: "The hardest part of this project for me was learning and remembering the collapse classes.",
        description: "This was the course project for the NuCamp Coding Bootcamp Bootstrap course. It represents a fictional campsite website. It is built using moduls, carousels, navbars etc. It is fully responsive on all screen sizes.",
        technology: "Bootstrap",
        git: "https://github.com/michaelLeeDeveloper/nucampBootstrap"
    }, {
        name: "Bootstrap Portfolio Website",
        src: perspectiveSoundImg,
        link: "#",
        title: "Perspective Sound",
        struggle: "The hardest part of this project was using a music API to display albums",
        description: "This website is a fictional NFT marketplace... STILL WORK IN PROGRESS. This is an ongoing project of mine that I am keeping fairly quiet. It started as my portfolio project for the NuCamp Bootstrap course and quickly turned into a project that I think could revolutionize the music industry using NFT's.",
        technology: "Bootstrap",
        git: "#"
    }, {
        name: "NuCamp Website",
        src: nucampReactImg,
        link: "https://nucampreactwebsite.netlify.app/home",
        title: "NuCamp Site",
        description: "This was the course project for the NuCamp Coding Bootcamp Bootstrap course. It represents a fictional campsite website. It is fully functional using Reactstrap and is modeled after the bootstrap course project. Throughout this project I learned to use React, React Router, Redux, and ReactStrap. In it's final form the website uses redux for it's state management and a json server to retrieve it's data.",
        struggle: "The hardest part of this project for me was using Redux.",
        technology: "React",
        git: "https://github.com/michaelLeeDeveloper/nucampReact"
    },
    {
        name: "Google",
        src: googleImg,
        link: "https://googlehomesiteproject.netlify.app/",
        description: "Throughout the odin project course online, it recommends projects that you should try. This was one of my first attemps at programming a single web page. It is built solely using basic HTML and CSS. This is a replication of the google homepage.",
        title: "Google Homepage",
        struggle: "The hardest part of this project was learning dev tools to match css formatting",
        technology: "HTML/CSS",
        git: "https://github.com/michaelLeeDeveloper/google_homepage"
    }, {
        name: "Rock Paper Scissors",
        src: rockPaperImg,
        link: "https://rockpscissors.netlify.app/",
        description: "This project is one of many within the odin project. A long guide for developers made by developers. This is a project that This is an app to play rock paper scissors",
        title: "Rock, Paper, Scissors",
        struggle: "The hardest part of this project was using vanilla javascript to add event listeners",
        technology: "HTML/CSS/JavaScript",
        git: "https://github.com/michaelLeeDeveloper/RockPaperScissors"
    },
    {
        name: "Candy Museum",
        src: candyMuseumImg,
        link: "https://museum-of-candy-project.netlify.app/",
        description: "This is part of the Full Stack Web Development Udemy Course. This was focusing on bootstrap and making web pages responsive.",
        title: "Candy Museum",
        struggle: "The hardest part of this project was making it responsive",
        technology: "HTML/CSS",
        git: "https://github.com/michaelLeeDeveloper/candyMuseum"
    }, {
        name: "Coin Flipper",
        src: coinFlipperImg,
        link: "https://coinflipperproject.netlify.app/",
        description: "This is part of the React Udemy Course. This is an app for flipping a coin. This application was to help learn the basics and fundamentals of changing state.",
        title: "Coin Flipper",
        struggle: "The hardest part of this project was learning how to manage state",
        technology: "React",
        git: "https://github.com/michaelLeeDeveloper/coinFlipper"
    },
    {
        name: "Color Boxes",
        src: colorBoxesImg,
        link: "https://react-color-boxes.netlify.app/",
        description: "This is part of the React Udemy Course. This is an app that changes color when clicked. This application was to help learn the basics of passing state through as props.",
        title: "Color Boxes",
        struggle: "The hardest part of this project was learning to change state with events",
        technology: "React",
        git: "https://github.com/michaelLeeDeveloper/reactColorBoxes"
    }, {
        name: "Dice Roll",
        src: diceRollImg,
        link: "https://reactdiceproject.netlify.app/",
        description: "This is part of the React Udemy Course. This is an app for rolling die. This application was to explain setting default props.",
        title: "Dice Roller",
        struggle: "The hardest part of this project was learning to change state with events",
        technology: "React",
        git: "https://github.com/michaelLeeDeveloper/diceRoll"
    },
    {
        name: "Hangman",
        src: hangmanImg,
        link: "https://reacthangmanexcercise.netlify.app/",
        description: "This is part of the React Udemy Course. This is a Udemy Excercise focusing on react. This excercise was based around fixing the logic and bugs to make the hangman game work.",
        title: "Hangman",
        struggle: "The hardest part of this project was passing state down as props",
        technology: "React",
        git: "https://github.com/michaelLeeDeveloper/hangman"
    }, {
        name: "Lights Out",
        src: lightsoutImg,
        link: "https://lightsoutproject.netlify.app/",
        description: "This is part of the React Udemy Course. This is a Udemy Excercise focusing on react. This excercise was based on fixing the logic and managing state.",
        title: "Lights Out",
        struggle: "The hardest part of this project was managing the game logic (having all grey boxes wins)",
        technology: "React",
        git: "https://github.com/michaelLeeDeveloper/lightsout"
    },
    {
        name: "Lottery",
        src: lotteryImg,
        link: "https://reactlotteryproject.netlify.app/",
        description: "This is part of the React Udemy Course. This is an app for generating lottery numbers",
        title: "Lottery Generator",
        struggle: "The hardest part of this project was learning to pass props",
        technology: "React",
        git: "https://github.com/michaelLeeDeveloper/lottery"
    },
    {
        name: "Pokemon Game",
        src: pokemonImg,
        link: "https://pokemonproject.netlify.app/",
        description: "This is part of the Full Stack Web Development Udemy Course. This is an app to randomly generate pokemon",
        title: "Pokemon Cards",
        struggle: "The hardest part of this project was using a Pokemon API",
        technology: "React",
        git: "https://github.com/michaelLeeDeveloper/pokemon"
    },
    {
        name: "Score Keeper",
        src: scoreKeeperImg,
        link: "https://scorekeeperproject.netlify.app/",
        description: "This is part of the Full Stack Web Development Udemy Course. This is an app to keep score",
        title: "Score Keeper",
        struggle: "The hardest part of this project was using event listeners.",
        technology: "HTML/Javascript",
        git: "https://github.com/michaelLeeDeveloper/scorekeeper"
    },
    {
        name: "To Do List",
        src: toDoImg,
        link: "https://to-dolist-react.netlify.app/",
        description: "This is part of the React Udemy Course. This is a to do list app",
        title: "To Do List",
        struggle: "The hardest part of this project was managing forms",
        technology: "React",
        git: "https://github.com/michaelLeeDeveloper/todolist"
    },
    {
        name: "Yahtzee",
        src: yahtzeeImg,
        link: "https://yahtzeereactgame.netlify.app",
        description: "This is part of the React Udemy Course. This is an app to track your yahtzee scorecard. This activity was focused on managing state and fixing functionality of the application.",
        title: "Yahtzee",
        struggle: "The hardest part of this project was managing the logic conditions",
        technology: "React",
        git: "https://github.com/michaelLeeDeveloper/yahtzee"
    },
    {
        name: "Dad Jokes",
        src: dadJokesImg,
        link: "https://reactdadjokes.netlify.app",
        description: "This is part of the React Udemy Course. This is a an app to generate dad jokes. This application helped teach me the axios library and using the componentDidMount function.",
        title: "Dad Jokes",
        struggle: "The hardest part of this project was using a dad jokes api with events",
        technology: "React",
        git: "https://github.com/michaelLeeDeveloper/dadJokes"
    }
]

export default projectInfo;